import SideBar from "../commun/SideBar";
import Hearder from "../commun/Hearder";

const amenitiesData = [
  { amenityName: "Free WiFi", iconClass: "wifi", amenityType: "Property" },
  { amenityName: "Parking", iconClass: "local_parking", amenityType: "Property" },
  { amenityName: "Restaurant", iconClass: "restaurant", amenityType: "Property" },
  { amenityName: "Room Service", iconClass: "room_service", amenityType: "Property" },
  { amenityName: "Bar", iconClass: "liquor", amenityType: "Property" },
  { amenityName: "24 Hour Front Desk", iconClass: "support_agent", amenityType: "Property" },
  { amenityName: "Fitness Center", iconClass: "fitness_center", amenityType: "Property" },
  { amenityName: "Spa & Wellness Centre", iconClass: "spa", amenityType: "Property" },
  { amenityName: "Airport Shuttle", iconClass: "airport_shuttle", amenityType: "Property" },
  { amenityName: "Business Center", iconClass: "business_center", amenityType: "Property" },
  { amenityName: "Laundry", iconClass: "local_laundry_service", amenityType: "Property" },
  { amenityName: "Dry Cleaning", iconClass: "dry_cleaning", amenityType: "Property" },
  { amenityName: "Family Rooms", iconClass: "family_restroom", amenityType: "Property" },
  { amenityName: "Garden", iconClass: "yard", amenityType: "Property" },
  { amenityName: "Terrace", iconClass: "deck", amenityType: "Property" },
  { amenityName: "Elevator", iconClass: "elevator", amenityType: "Property" },
  { amenityName: "Non Smoking Rooms", iconClass: "smoke_free", amenityType: "Property" },
  { amenityName: "Safe Deposit Box", iconClass: "lock", amenityType: "Property" },
  { amenityName: "Children Playground", iconClass: "toys", amenityType: "Property" },
  { amenityName: "Meeting & Banquet Facilities", iconClass: "groups", amenityType: "Property" },

  { amenityName: "Air Conditioning", iconClass: "ac_unit", amenityType: "Room" },
  { amenityName: "TV", iconClass: "tv", amenityType: "Room" },
  { amenityName: "Telephone", iconClass: "call", amenityType: "Room" },
  { amenityName: "Mini Bar", iconClass: "liquor", amenityType: "Room" },
  { amenityName: "Coffee Maker", iconClass: "coffee", amenityType: "Room" },
  { amenityName: "Hair Dryer", iconClass: "air", amenityType: "Room" },
  { amenityName: "Balcony", iconClass: "balcony", amenityType: "Room" },
  { amenityName: "Refrigerator", iconClass: "kitchen", amenityType: "Room" },
  { amenityName: "Microwave", iconClass: "microwave", amenityType: "Room" },
  { amenityName: "Kitchen", iconClass: "countertops", amenityType: "Room" },
  { amenityName: "Electric Kettle", iconClass: "electric_bolt", amenityType: "Room" },
  { amenityName: "Desk", iconClass: "desk", amenityType: "Room" },
  { amenityName: "Sofa", iconClass: "weekend", amenityType: "Room" },
  { amenityName: "Dining Area", iconClass: "table_restaurant", amenityType: "Room" },
  { amenityName: "Flat Screen TV", iconClass: "tv", amenityType: "Room" },
  { amenityName: "Sea View", iconClass: "waves", amenityType: "Room" },
  { amenityName: "Mountain View", iconClass: "landscape", amenityType: "Room" },
  { amenityName: "Garden View", iconClass: "park", amenityType: "Room" },
  { amenityName: "Pool View", iconClass: "pool", amenityType: "Room" },
  { amenityName: "City View", iconClass: "location_city", amenityType: "Room" }
];

const Amenities = () => {
  return (
    <>
      <div className="wrapper">
        <SideBar />

        <div className="main-panel">
          <Hearder />

          <div className="container">
            <div className="page-inner">
              <div className="container-custom amenities-page">

                {/* Header */}
                <header className="amenities-header">
                  <h1 className="headline-lg">Select Your Amenities</h1>
                  <p className="body-md text-secondary">
                    Personalize your stay with our premium services.
                  </p>
                </header>

                {/* Property Amenities */}
                <div className="mb-2">
                  <h2 className="mb-4">Property Amenities</h2>

                  <div className="row g-4">
                    {amenitiesData
                      .filter(item => item.amenityType === "Property")
                      .map((item, index) => (
                        <div className="col-sm-6 col-lg-3" key={index}>
                          <label className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />

                            <div className="amenity-content">
                              <span className="material-symbols-outlined">
                                {item.iconClass}
                              </span>

                              <div className="amenity-text">
                                <h3 className="title-md">
                                  {item.amenityName}
                                </h3>

                                <p className="label-sm">
                                  {item.amenityType}
                                </p>
                              </div>
                            </div>
                          </label>
                        </div>
                      ))}
                  </div>
                </div>

                {/* Room Amenities */}
                <div className="mb-4">
                  <h2 className="mb-4">Room Amenities</h2>

                  <div className="row g-4">
                    {amenitiesData
                      .filter(item => item.amenityType === "Room")
                      .map((item, index) => (
                        <div className="col-sm-6 col-lg-3" key={index}>
                          <label className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />

                            <div className="amenity-content">
                              <span className="material-symbols-outlined">
                                {item.iconClass}
                              </span>

                              <div className="amenity-text">
                                <h3 className="title-md">
                                  {item.amenityName}
                                </h3>

                                <p className="label-sm">
                                  {item.amenityType}
                                </p>
                              </div>
                            </div>
                          </label>
                        </div>
                      ))}
                  </div>
                </div>

                {/* Footer */}
                <div className="footer-info d-flex justify-content-end">
                  <button className="btn btn-primary">
                    Submit
                  </button>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default Amenities;